<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="drawer"
    app
    dark
    fixed
    width="300px"
    touchless
  >
    <!-- API TEST -->
    <!-- <v-btn light to="/api">API</v-btn> -->
    <!-- END API TEST -->

    <v-list
      dense
      class=""
    >
      <template v-for="(item, rootIndex) in items">
        <!-- Group with sub items -->
        <v-list-group
          v-if="item.items"
          :key="rootIndex"
          :group="item.group"
          :prepend-icon="item.icon"
          no-action
        >
          <v-list-item
            slot="activator"
            ripple
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- Sub item -->
          <v-list-item
            v-for="(subItem, i) in item.items"
            :key="i"
            :to="!subItem.external ? subItem.href : null"
            :href="subItem.external ? subItem.href : null"
            ripple
          >
            <v-list-item-content>
              <v-list-item-title>{{ subItem.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <!-- Subheader -->
        <v-subheader
          v-else-if="item.header"
          :key="rootIndex"
          class="mt-4"
        >
          {{ item.header }}
        </v-subheader>

        <!-- Top-level tile -->
        <v-list-item
          v-else
          :key="rootIndex"
          :to="!item.external ? item.href : null"
          :href="item.external ? item.href : null"
          rel="noopener"
          ripple
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.title }}
              <template v-if="item.count">
                <span
                  v-if="item.href === '/groups'"
                  class="ml-1 grey--text"
                >({{ groups.length }})</span>
                <span
                  v-if="item.href === '/email_alerts'"
                  class="ml-1 grey--text"
                >({{ emailAlerts.length }})</span>
                <span
                  v-if="item.href === '/tracked_backtests'"
                  class="ml-1 grey--text"
                >({{ trackedBacktests.length }})</span>
              </template>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// Modules
import { mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'

// Static data
import menuItems from '@/data/menu-items'

export default {
  data: () => ({
    items: menuItems
  }),

  computed: {
    ...mapState('user', ['groups', 'emailAlerts', 'trackedBacktests']),
    ...mapFields({
      drawer: 'app.drawer'
    })
  }
}
</script>

<style>

</style>
